import {MentalBaseSymbol} from "../MentalBaseSymbol";
import {TimelineLite, TweenLite} from "gsap";
import {Mental} from "../../Mental";
import {MentalSymbolStates,} from "../MentalSymbol";
import {MentalSymbolMultiplier} from "./multiplier/MentalSymbolMultiplier";
import {FeaturePresentationHelper} from "../../utils/FeaturePresentationHelper";
import {SoundManager} from "../../sound/SoundManager";

export class MentalNormalSymbol extends MentalBaseSymbol {
    public _symbolLayer: PIXI.Container;
    public _topLayer: PIXI.Container;
    public _symbolMultiplierValue: number = 1;
    // array contains split symbols
    public _splitSymbols: MentalNormalSymbol[] = [];
    public readonly _symbolMultiplier: MentalSymbolMultiplier;
    public _multiplierAlreadyResized: boolean = false; // to fix #289
    protected _spin: PIXI.Sprite;
    protected currentAnimation: TimelineLite;
    // layers of reel
    private readonly _spineState: PIXI.spine.Spine;
    private state: MentalSymbolStates;
    private readonly _noWinOverlay: PIXI.Sprite;

    constructor(name: string) {
        super(name);

        if (name !== "W3") {
            this._spin = MentalBaseSymbol.createSpinSprite(name);

            this._spineState = new PIXI.spine.Spine(Mental.assetLoader.getSpineAsset(name));
            this._spineState.visible = false;
        }

        this._noWinOverlay = MentalBaseSymbol.createNoWinOverlay();

        this._symbolLayer = this.layerSet.layers[0];
        this._topLayer = this.layerSet.layers[1];
        this._symbolMultiplier = new MentalSymbolMultiplier(this._symbolMultiplierValue);

        this.currentSymbolHeight = 198;
    }

    private _allowedToResizeSegments: boolean;

    get allowedToResizeSegments(): boolean {
        return this._allowedToResizeSegments;
    }

    set allowedToResizeSegments(value: boolean) {
        this._allowedToResizeSegments = value;
    }

    public setState(state: MentalSymbolStates, toHeight: number = this.currentSymbolHeight, canSkipWildAnim: boolean = false): void {
        if (this.setSplitState(state, toHeight, canSkipWildAnim)) {
            return;
        }
        if (this.state === state) {
            return;
        }

        if ((!(state === MentalSymbolStates.NO_WIN || state === MentalSymbolStates.NO_WIN_DARK || this.isAnticipatingState(state)))) {
            this.clearState();
        }

        this.applyTint(0xffffff);

        switch (state) {
            case MentalSymbolStates.SPIN:
                //this._spin.tint = 0x9c9c9c;  // spin darkness
                this._symbolLayer.addChild(this._spin);
                this.currentTextureState = this._spin;
                this.currentSymbolHeight = 198;
                break;
            case MentalSymbolStates.LANDING:
                this.setLandingState();
                break;
            case MentalSymbolStates.ONE_FORTY_EIGHT:
                this.setResizeState(toHeight, "198_to_148", canSkipWildAnim);
                break;
            case MentalSymbolStates.ONE_THIRTY_TWO:
                this.setResizeState(toHeight, "148_to_132", canSkipWildAnim);
                break;
            case MentalSymbolStates.ONE_HUNDRED_EIGHTEEN:
                this.setResizeState(toHeight, "132_to_118", canSkipWildAnim);
                break;
            case MentalSymbolStates.NINETY_NINE:
                this.setResizeState(toHeight, "118_to_99", canSkipWildAnim);
                break;
            case MentalSymbolStates.EIGHTY_FOUR:
                this.setResizeState(toHeight, "99_to_84", canSkipWildAnim);
                break;
            case MentalSymbolStates.SEVENTY_FOUR:
                this.setResizeState(toHeight, "84_to_74", canSkipWildAnim);
                break;
            case MentalSymbolStates.SIXTY_SIX:
                this.setResizeState(toHeight, "74_to_66", canSkipWildAnim);
                break;
            case MentalSymbolStates.SIXTY:
                this.setResizeState(toHeight, "66_to_60", canSkipWildAnim);
                break;
            case MentalSymbolStates.FIFTY_SIX:
                this.setResizeState(toHeight, "60_to_56", canSkipWildAnim);
                break;
            case MentalSymbolStates.FIFTY:
                this.setResizeState(toHeight, "56_to_50", canSkipWildAnim);
                break;
            case MentalSymbolStates.FORTY_FIVE:
                this.setResizeState(toHeight, "50_to_45", canSkipWildAnim);
                break;
            case MentalSymbolStates.FORTY:
                this.setResizeState(toHeight, "45_to_40", canSkipWildAnim);
                break;
            case MentalSymbolStates.THIRTY_TWO:
                this.setResizeState(toHeight, "40_to_32", canSkipWildAnim);
                break;
            case MentalSymbolStates.TWENTY_SIX:
                this.setResizeState(toHeight, "32_to_26", canSkipWildAnim);
                break;
            case MentalSymbolStates.NO_WIN:
                this.currentTextureState.tint = 0xadadad;
                this._symbolMultiplier.multi.tint = 0xadadad;
                break;
            case MentalSymbolStates.NO_WIN_DARK:
                this.currentTextureState.tint = 0x959595;
                this._symbolMultiplier.multi.tint = 0x959595;
                break;
            case MentalSymbolStates.STANDARD_FS_ANTICIPATION:
                this.currentTextureState.tint = 0x666666;
                this._symbolMultiplier.multi.tint = 0x666666;
                break;
            case MentalSymbolStates.COOL_FS_ANTICIPATION:
                this.currentTextureState.tint = 0x444444;
                this._symbolMultiplier.multi.tint = 0x444444;
                break;
            case MentalSymbolStates.SUPER_FS_ANTICIPATION:
                this.currentTextureState.tint = 0x222222;
                this._symbolMultiplier.multi.tint = 0x222222;
                break;
            default:
                // stack specific
                if (this.symbolName.indexOf("W3") > -1) {
                    // this._normalSymbol.position.set(0, 0);
                } else {
                    this.setResizeState(198, "198_to_198");
                }
                this.currentSymbolHeight = 198;
                break;
        }
        this.state = state;

        if (!(state === MentalSymbolStates.NO_WIN || state === MentalSymbolStates.NO_WIN_DARK || this.isAnticipatingState(state))) {
            this.addMultiplier();
        }
    }

    public getWinAnimation(): TimelineLite {
        const duration: number = 0.7,
            tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            this.setState(MentalSymbolStates.WIN);
        });

        tl.add(TweenLite.to(this, duration, {}));
        this.currentAnimation = tl;
        return tl;
    }

    public split(segments: number, revealSymbol: string, parts: number = 2, multiplier: number[] = []): void {
        // commented this code to turn dead to gold symbol by calling split :- check for any errors
        if (segments == 1 && this.symbolName.indexOf("D") === -1) {
            return;
        }
        this.clearSplit();
        const pool = Mental.graphicsPool.getSymbolPool(revealSymbol);
        for (let i: number = 0; i < segments; i++) {
            const symbol = <MentalNormalSymbol>pool.withdraw();
            const segmentSize = 198 / parts;
            if (multiplier.length) {
                symbol._symbolMultiplierValue = multiplier[i];
            } else {
                symbol._symbolMultiplierValue = this._symbolMultiplierValue;
            }
            this._splitSymbols.push(symbol);
            symbol.setState(MentalSymbolStates.NONE);
            symbol.resizeSymbol(segmentSize, 1, i, false);
        }
    }

    public splitInMultiSymbols(segments: number, revealSymbol: string[], multiplier: number[] = []): void {
        if (segments == 1) {
            return;
        }
        this.clearSplit();
        for (let i: number = 0; i < segments; i++) {
            const pool = Mental.graphicsPool.getSymbolPool(revealSymbol[i]);
            const symbol = <MentalNormalSymbol>pool.withdraw();
            if (multiplier.length) {
                symbol._symbolMultiplierValue = multiplier[i];
            } else {
                symbol._symbolMultiplierValue = this._symbolMultiplierValue;
            }
            const segmentSize = 198 / segments;
            this._splitSymbols.push(symbol);
            symbol.setState(MentalSymbolStates.NONE);
            symbol.resizeSymbol(segmentSize, 1, i, false);
        }
    }

    public clear(): void {
        this.clearSplit();

        if (this.currentAnimation) {
            this.currentAnimation.kill();
        }
        this._allowedToResizeSegments = false;

        if (this._splitSymbols.length != 0) {
            throw new Error("Split symbols is not cleared properly");
        }
        this._symbolMultiplierValue = 1;
        this._multiplierAlreadyResized = false;
        super.clear();
    }

    public resizeSymbol(segmentSize: number, segments: number, segmentIndex: number, animated: boolean = true): TimelineLite {
        const segmentPosition: number = segmentSize * segmentIndex;
        const tl: TimelineLite = new TimelineLite();
        const scaleY: number = segmentSize * segments / 198;
        if (this._splitSymbols && this._splitSymbols.length == segments) {
            for (let i: number = 0; i < this._splitSymbols.length; i++) {
                const symbol = <MentalNormalSymbol>this._splitSymbols[i];
                tl.add(symbol.resizeSymbol(segmentSize, 1, i, animated), 0);
            }
        }

        if (animated) {
            tl.eventCallback("onStart", () => {
                if (this.offsetPosition.y == 0) {
                    this.offsetPosition.set(this.position.x, this.position.y);
                }
            });
            // copy ease later
            tl.add(TweenLite.to(this.scale, 0.2, {y: scaleY}), 0);
            tl.add(TweenLite.to(this.offsetPosition, 0.2, {y: segmentPosition}), 0);
        } else {
            this.offsetPosition.set(this.position.x, segmentPosition);
            TweenLite.set(this.scale, {y: scaleY});
        }

        return tl;
    }

    public getSegmentCount(): number {
        if (this._splitSymbols.length == 0 || !this._allowedToResizeSegments) {
            return 1;
        }
        return this._splitSymbols.length;
    }

    public getNoWinAnimation(): TimelineLite {
        return new TimelineLite();
    }

    public getToggleAnimation(): TimelineLite {
        return this.getWinAnimation();
    }

    public setStateAsPerParts(parts: number, canSkipWildAnim: boolean = false): void {
        const height: number = 198 / parts,
            actualHeight: number = FeaturePresentationHelper._possibleSymbolSizes.reduce((prev: number, curr: number) => {
                return (Math.abs(curr - height) < Math.abs(prev - height) ? curr : prev);
            });

        switch (actualHeight) {
            case 198:
                this.setState(MentalSymbolStates.NONE, 198);
                break;
            case 148:
                this.setState(MentalSymbolStates.ONE_FORTY_EIGHT, height, canSkipWildAnim);
                break;
            case 132:
                this.setState(MentalSymbolStates.ONE_THIRTY_TWO, height, canSkipWildAnim);
                break;
            case 118:
                this.setState(MentalSymbolStates.ONE_HUNDRED_EIGHTEEN, height, canSkipWildAnim);
                break;
            case 99:
                this.setState(MentalSymbolStates.NINETY_NINE, height, canSkipWildAnim);
                break;
            case 84:
                this.setState(MentalSymbolStates.EIGHTY_FOUR, height, canSkipWildAnim);
                break;
            case 74:
                this.setState(MentalSymbolStates.SEVENTY_FOUR, height, canSkipWildAnim);
                break;
            case 66:
                this.setState(MentalSymbolStates.SIXTY_SIX, height, canSkipWildAnim);
                break;
            case 60:
                this.setState(MentalSymbolStates.SIXTY, height, canSkipWildAnim);
                break;
            case 56:
                this.setState(MentalSymbolStates.FIFTY_SIX, height, canSkipWildAnim);
                break;
            case 50:
                this.setState(MentalSymbolStates.FIFTY, height, canSkipWildAnim);
                break;
            case 45:
                this.setState(MentalSymbolStates.FORTY_FIVE, height, canSkipWildAnim);
                break;
            case 40:
                this.setState(MentalSymbolStates.FORTY, height, canSkipWildAnim);
                break;
            case 32:
                this.setState(MentalSymbolStates.THIRTY_TWO, height, canSkipWildAnim);
                break;
            case 26:
                this.setState(MentalSymbolStates.TWENTY_SIX, height, canSkipWildAnim);
                break;
        }
    }

    public showSymbolMultiplier(): void {
        if (this._symbolMultiplierValue <= 1) {
            return;
        }

        this._symbolMultiplier.multi.scale.set(1); // to fix #300
        if (this.state === MentalSymbolStates.FIFTY) {
            // this._symbolMultiplier.multi.scale.set(0.8); // to fix #300
            this._symbolMultiplier.updateMultiplier(this._symbolMultiplierValue);
        }

        // #247 -> safe check, no harm
        this.addMultiplier();

        this._symbolMultiplier.visible = true;

        SoundManager.playMultiplierSound(this._symbolMultiplierValue);
    }

    public addMultiplier(): void {
        if (this._symbolMultiplierValue > 1) {
            this._topLayer.addChild(this._symbolMultiplier);
            this._symbolMultiplier.updateMultiplier(this._symbolMultiplierValue);
            FeaturePresentationHelper.repositionMultiplierOnResize(this);
        }
    }

    public isAnticipatingState(state: MentalSymbolStates): boolean {
        return (state === MentalSymbolStates.STANDARD_FS_ANTICIPATION || state === MentalSymbolStates.COOL_FS_ANTICIPATION || state === MentalSymbolStates.SUPER_FS_ANTICIPATION);
    }

    public getState(): MentalSymbolStates {
        return this.state;
    }

    // #148
    public getTint(): number {
        return this.currentTextureState.tint;
    }

    // #148
    public applyTint(value: number): void {
        if (this.currentTextureState) {
            this.currentTextureState.tint = value;
            this._symbolMultiplier.multi.tint = value;
        }
        // don't use setState method, we just want to update state name, used for #148.
        this.state = MentalSymbolStates.NONE;
    }

    private clearSplit(): void {
        for (let i: number = this._splitSymbols.length - 1; i >= 0; i--) {
            const splitSymbol: MentalNormalSymbol = this._splitSymbols[i];
            splitSymbol.clear();
            this.layerSet.removeLayerSet(splitSymbol.layerSet);
            this._splitSymbols.splice(i, 1);
            Mental.graphicsPool.getSymbolPool(splitSymbol.symbolName).deposit(splitSymbol);
        }
    }

    private clearState(): void {
        for (let layer of this.layerSet.layers) {
            layer.removeChildren();
        }
        if (this._spineState) {
            this._spineState.state.clearTracks();

            this._symbolLayer.removeChild(this._spineState);
        }
    }

    private setSplitState(state: MentalSymbolStates, toHeight: number, canSkipWildAnim: boolean = false): boolean {
        if (this._splitSymbols.length > 0 && this.allowedToResizeSegments) {
            this.clearState();
            for (let i = 0; i < this._splitSymbols.length; i++) {
                const splitSymbol: MentalNormalSymbol = this._splitSymbols[i];
                splitSymbol._topLayer.position.y = splitSymbol._symbolLayer.position.y;
                splitSymbol.setState(state, toHeight, canSkipWildAnim);
                this.layerSet.layers[0].name = "root";
                this.layerSet.addLayerSet(splitSymbol.layerSet);
                this._topLayer.position.y = this._symbolLayer.position.y;
                this._symbolMultiplier.position.y = this._symbolLayer.height - this._symbolMultiplier.height;
            }
            return true;
        } else {
            return false;
        }
    }

    private setResizeState(toHeight: number, animName: string, canSkipAnim: boolean = false): void {
        this.resetSpine(this._spineState);

        const to: number = toHeight;

        this._spineState.position.set(72, to / 2);
        this._spineState.state.setAnimation(0, animName, false);

        this.currentTextureState = this._spineState;
        this.currentSymbolHeight = to;

        if (this.symbolName === "W") {
            if (canSkipAnim) {
                this._spineState.state.tracks[0].animationStart = this._spineState.state.tracks[0].trackEnd;
                this._spineState.state.tracks[0].animationEnd = this._spineState.state.tracks[0].trackEnd;
            }
        }
    }

    private setLandingState(): void {
        this.resetSpine(this._spineState);

        this._spineState.position.set(72, 99);
        this._spineState.state.setAnimation(0, "landing", false);

        this.currentTextureState = this._spineState;
        this.currentSymbolHeight = 198;
    }

    private resetSpine(spine: PIXI.spine.Spine): void {
        this._symbolLayer.addChild(this._spineState);

        spine.skeleton.setSlotsToSetupPose();
        spine.skeleton.setToSetupPose();
        spine.state.clearTracks();
        spine.state.setEmptyAnimation(0, 0);

        if (!spine.visible) {
            spine.visible = true;
            spine.updateTransform();
        }
    }
}